module.exports = __webpack_public_path__ + "static/img/konka_item.e648b59e.png";